
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting USER_ERROR types, which identify a class of issues related to the creation or management of a User.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='User errors' subtitle='Guide to troubleshooting User errors' mdxType="Header" />
    <h4 {...{
      "id": "user_not_found"
    }}><strong parentName="h4">{`USER_NOT_FOUND`}</strong></h4>
    <ErrorReference type='USER_ERROR' error='USER_NOT_FOUND' subtitle='The provided `user_id` could not be found.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`user_id`}</inlineCode>{` was never created.`}</li>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`user_id`}</inlineCode>{` was created in a different environment (Sandbox vs Production).`}</li>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`user_id`}</inlineCode>{` was previously deleted via `}<inlineCode parentName="li">{`/user/remove`}</inlineCode>{`.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='USER_NOT_FOUND1' mdxType="Checkbox">
        <p>{`Ensure you're using the correct API environment (Sandbox or Production) that matches where the `}<inlineCode parentName="p">{`user_id`}</inlineCode>{` was created.`}</p>
      </Checkbox>
      <Checkbox checklistId='USER_NOT_FOUND2' mdxType="Checkbox">
        <p>{`Confirm the `}<inlineCode parentName="p">{`user_id`}</inlineCode>{` format is correct (should start with `}<inlineCode parentName="p">{`usr_`}</inlineCode>{`, or `}<inlineCode parentName="p">{`user-`}</inlineCode>{` if migrating a legacy user)`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "user_not_found",
        level: 4,
        title: "USER_NOT_FOUND",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
